function Cursor() {
    return(
    <section>
      <div className="cursor" id="cursor"></div>
      
    </section>
  );
}
export default Cursor;